import { lazy } from 'react';

// Dashboard with charts - prefetch charts and query chunks
export const LazyDashboard = lazy(() => 
  import(/* webpackChunkName: "dashboard" */ '@/pages/Dashboard')
    .then(module => ({ default: module.Dashboard }))
);
